import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';

import { ApplicationContext } from '../../../../../shared/source/context/context';
import { paginationCountResponseSchema } from '../../../../../shared/source/data-contract/pagination';

import type { PaginationCountResponse } from '../../../../../shared/source/data-contract/pagination';
import type { Pathname } from '../../../../../shared/source/http-fetcher/http-fetcher';
import type { TabParam } from '../../pages/talent-directory/use-talent-directory-params';
import type { UseQueryResult } from '@tanstack/react-query';

const useQueryCount = (pathname: Pathname, enabled: boolean): UseQueryResult<PaginationCountResponse> => {
    const { validatingCobrainerApiFetcher } = useContext(ApplicationContext);
    const searchParams = {
        countOnly: true,
    };

    return useQuery({
        enabled,
        queryFn: async () => {
            const result = await validatingCobrainerApiFetcher.get(paginationCountResponseSchema, {
                pathname,
                requestOptions: {
                    searchParams,
                },
            });

            if (result.isOk) {
                return result.value;
            }

            throw result.error;
        },
        queryKey: [pathname, 'get', paginationCountResponseSchema, searchParams],
        throwOnError: false,
    });
};

// eslint-disable-next-line complexity
export const useTalentDirectoryCounts = (tabs: readonly TabParam[]): Record<TabParam, number> => ({
    employees: useQueryCount('/global/directory/users', tabs.includes('employees'))?.data?.pagination?.count ?? 0,
    jobs: useQueryCount('/global/directory/jobs', tabs.includes('jobs'))?.data?.pagination?.count ?? 0,
    learningOpportunities:
        useQueryCount('/global/directory/learning-opportunities', tabs.includes('learningOpportunities'))?.data
            ?.pagination?.count ?? 0,
    skills: useQueryCount('/global/directory/skills', tabs.includes('skills'))?.data?.pagination?.count ?? 0,
});
